<template>
    <div id="share-house">
        <landlord-auth></landlord-auth>
        <download-app-menu v-if="system !== 'pc'"></download-app-menu>
        <div v-if="isPublish || houseStatus == 2 || isPreview || isContract" class="container" :class="{'mb-pt': system !== 'pc'}">
            <div class="row eval-and-award-wrap">
                <div class="col">
                    <evaluation-and-award></evaluation-and-award>
                </div>
            </div>
            <div class="row house-content">
                <div class="left" :class="$route.query.mode == 'contract'?'col-12':'col-lx-6 col-lg-6 col-md-12 col-sm-12'">
                    <house-slider v-if="$route.query.mode != 'contract'"></house-slider>
                    <div class="block">
                        <house-feature-mb></house-feature-mb>
                        <house-info></house-info>
                    </div>
                    <div class="block">
                        <equipment></equipment>
                    </div>
                    <div class="block" v-if="hasRules && hasRentInclude">
                        <notice></notice>
                    </div>
                    <div class="block">
                        <house-map></house-map>
                    </div>
                    <div class="block">
                        <evaluation-count></evaluation-count>
                        <evaluation-comment></evaluation-comment>
                    </div>
                    <div class="block">
                        <landlord-info></landlord-info>
                    </div>
                    <div class="block">
                        <other-condition></other-condition>
                    </div>
                    <div v-if="houseGroupList.length" class="block">
                        <house-group></house-group>
                    </div>
                </div>
                <div v-if="$route.query.mode != 'contract'" class="right col-lx-4 col-lg-4 col-md-12 col-sm-12">
                    <house-feature></house-feature>
                </div>
            </div>
        </div>
        <not-publish></not-publish>
        <download-app></download-app>
    </div>
</template>
<script>
import houseFeature from '@/components/shareHouse/houseFeature.vue';
import houseFeatureMb from '@/components/shareHouse/houseFeatureMb.vue';
import evaluationAndAward from '@/components/shareHouse/evaluationAndAward.vue';
import reportHouse from '@/components/shareHouse/reportHouse.vue';
import houseSlider from '@/components/shareHouse/houseSlider.vue';
import houseInfo from '@/components/shareHouse/houseInfo.vue';
import equipment from '@/components/shareHouse/equipment.vue';
import notice from '@/components/shareHouse/notice.vue';
import houseMap from '@/components/shareHouse/houseMap.vue';
import evaluationCount from '@/components/shareHouse/evaluationCount.vue';
import evaluationComment from '@/components/shareHouse/evaluationComment.vue';
import landlordInfo from '@/components/shareHouse/landlordInfo.vue';
import otherCondition from '@/components/shareHouse/otherCondition.vue';
import houseGroup from '@/components/shareHouse/houseGroup.vue';
import notPublish from '@/components/shareHouse/notPublish.vue';
import downloadApp from '@/components/shareHouse/downloadApp.vue';
import downloadAppMenu from '@/components/shareHouse/downloadAppMenu.vue';
import landlordAuth from '@/components/shareHouse/landlordAuth.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return{
            isPreview: this.$route.query.mode === 'preview'?true:false,
            isContract: this.$route.query.mode === 'contract'?true:false
        }
    },
    mounted () {
        // this.$route.query.cid
        // console.log(this.$route.query.mode)
        if(this.houseCid){
            this.getHouseDetail(this.houseCid)
        }else{
            this.getHouseDetail(this.$route.query.cid)
        }
    },
    props: {
        houseCid: Number
    },
    watch: {
        $route:{
            handler: function (val) {
                if(this.houseCid){
                    this.getHouseDetail(this.houseCid)
                }else{
                    this.getHouseDetail(val.query.cid)
                }
            },
            immediate: true,
            deep: true
        },
        isPublish: {
            handler: function (val){
                // console.log(!val)
                // console.log(this.$route.query.mode != 'contract')
                // console.log(this.$route.query.mode != 'preview')
                if(!val && this.$route.query.mode != 'contract' && this.$route.query.mode != 'preview'){
                    this.$store.dispatch('setModalStatus', {state: true, type: 'notPublish'})
                }
            },
            immediate: true
        },
    },
    methods: {
        getHouseDetail: function (cid) {
            this.$store.dispatch('getShareHouseDetail', cid)
            .then(() => {
                this.$emit('loaded')
            })
            this.$store.dispatch('getShareHouseRateComment', {'cid': cid, 'page': 1})
            
        }
    },
    computed: {
        hasRules: function () {
            let hasRules = false
            if(this.rules && this.rules.length > 0){
                this.rules.map( (item, index) => {
                    if(item.check == true){
                        hasRules = true
                    }
                })
                return hasRules
            }
        },
        hasRentInclude: function () {
            let hasRentInclude = false
            if(this.rentInclude && this.rentInclude.length > 0){
                this.rentInclude.map( (item, index) => {
                    if(item.check == true){
                        hasRentInclude = true
                    }
                })
                return hasRentInclude
            }
        },
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            rentInclude: 'GET_SHARE_HOUSE_RENT_INCLUDE',
            rules: 'GET_SHARE_HOUSE_RULES',
            policy: 'GET_SHARE_HOUSE_POLICY',
            isPublish: 'GET_SHARE_HOUSE_IS_PUBLISH',
            houseStatus: 'GET_SHARE_HOUSE_STATUS',
            houseGroupList: 'GET_SHARE_HOUSE_HOUSE_GROUP',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        houseFeature,
        houseFeatureMb,
        evaluationAndAward,
        reportHouse,
        houseSlider,
        houseInfo,
        equipment,
        notice,
        houseMap,
        evaluationCount,
        evaluationComment,
        landlordInfo,
        otherCondition,
        notPublish,
        downloadApp,
        houseGroup,
        downloadAppMenu,
        landlordAuth
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/css/bootstrap-grid.css';

    #share-house{
        margin-top: 12px;
        .container{
            &.mb-pt{
                padding-top: 52px;
            }
            .eval-and-award-wrap{
                margin-bottom: 11px;
            }
            .house-content{
                margin-bottom: 60px;
                .gallery{
                    margin-bottom: 10px;
                }
                .block{
                    padding: 24px 0;
                    border-bottom: solid 1px #d7d9db;
                    &:last-child{
                        border: none;
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        #share-house{
            margin-top: 0px;
            .container{
                .eval-and-award-wrap{
                    margin-bottom: 0px;
                }
                .house-content{
                    .gallery{
                        margin-bottom: 0px;
                    }
                    .block{
                        padding: 20px 0;
                    }
                    .right{
                        display: none;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/shareHouse/shareHouse.vue